import { PaginationDirection } from './PaginationDirection'

export const puiPaginationSlots = {
  previous: () => <PaginationDirection direction="prev" />,
  next: () => <PaginationDirection direction="next" />,
}
